import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import { getYesNoOptionalOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export interface ExpenseCommentsSegmentedControlProps {
  name: string;
  id: string;
}

export function ExpenseCommentsSegmentedControl({
  name,
  id,
}: ExpenseCommentsSegmentedControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookSegmentedControlWrapper
      width="100%"
      id={id}
      control={control}
      label="Require expense comments?"
      name={name}
      defaultValue="No"
      options={getYesNoOptionalOptions(id)}
    />
  );
}
